// extracted by mini-css-extract-plugin
export var banner = "_42-0";
export var icon = "_42-1";
export var message = "_42-2";